// extracted by mini-css-extract-plugin
module.exports = {"disabled":"SliderArrow_disabled__2EY3i","arrow":"SliderArrow_arrow__Q9UL7"};